import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectProviderOnboarding = createSelector(
  [(state: AppState) => state.shared.providerOnboarding],
  providerOnboarding => providerOnboarding,
);
